export default __webpack_public_path__ + "ad6ff4265cbed5fb51092817ff979c7d.png";